module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ppelv20-2a436bb0bb391f837a0798555df9c1c5.jpg";